<h2 mat-dialog-title>Tips for Editing {{ businessType }} Listing</h2>
<mat-dialog-content class="mat-typography">
  <div>The standard listing template includes sections and fields for different types of businesses and services.</div>
  <div class="help-dialog__red-callout">Only complete sections that apply to your business and leave others blank or unchecked. Only sections that contain
    information will be shown on your listing. All others that do not apply will be hidden automatically.</div>
  <div class="help-dialog__indented">
    <div class="help-dialog__header">Editing Controls:</div>

    <div class="help-dialog__section-header">
      <div class="help-dialog__section-header-name">Edit Mode</div>
      <img src="assets/images/editmode.png">
    </div>
    <div class="help-dialog__section-text">To put your listing into Edit Mode, use the slider control located
      directly above your business name on your listing page. This control is only visible to the listing
      manager. The editing controls shown below will not be visible unless the listing is in Edit Mode. When
      finished editing your listing, switch Edit Mode back off and all of your changes will be saved and
      immediately visible to the public.</div>

    <div class="help-dialog__section-header">
      <div class="help-dialog__section-header-name">Blue Pencil Control</div>
      <img src="assets/images/pencil.png">
    </div>
    <div class="help-dialog__section-text">Click the Blue Pencil icon to edit individual sections. Most
      sections do not have an additional Save button but there are some that require Saving before closing
      the window. Check for a Save button or icon before closing a section.</div>

    <div class="help-dialog__section-header">
      <div class="help-dialog__section-header-name">Green Plus Control</div>
      <img src="assets/images/addbutton.png">
    </div>
    <div class="help-dialog__section-text">Click the Green Plus icon to add information to specific fields or
      sub-sections. Most sections or fields edited using the Green Plus control will require using the Save
      button before closing the window in order to save the information.</div>

    <div class="help-dialog__section-header">
      <div class="help-dialog__section-header-name">Grey Save Icon</div>
      <img src="assets/images/disk.png">
    </div>
    <div class="help-dialog__section-text">Some sub-sections and fields may have a Grey Save icon next to them.
      Click this to save the information after entering data or editing.</div>

    <div class="help-dialog__section-header-wrap">
      <div class="help-dialog__section-container">
        <div class="help-dialog__section-header-name">Location Map</div>
        <div class="help-dialog__section-text-wrap">While in Edit Mode, the red map marker on the location map can
          be moved to indicate the physical location of the business on the field. Click the red marker
          with the mouse and hold while dragging. The location map can be put into full screen using the
          icon in the upper right corner to make it easier to place the red map marker.</div>
      </div>
      <img src="assets/images/mapexample.png">
    </div>

    <div class="help-dialog__section-spacer"></div>

    <div class="help-dialog__section-header-wrap">
      <div class="help-dialog__section-container">
        <div class="help-dialog__section-header-name">Verify Listing Box</div>
        <div class="help-dialog__section-text-wrap">Below your business name and address near the top of the listing
          page, you will see a blue Verify Listing box. This is used to verify all the information is correct
          on your listing, even when no changes need to be made. We recommend that you visit your listing page
          every 3 months to make sure all of your information is correct. If everything is up-to-date, check
          the green &quot;Verify Listing&quot; checkbox located in the large blue block. This will update the
          last verified date on your listing which is visible to the public.</div>
      </div>
      <img src="assets/images/verifybox.png">
    </div>

  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button class="submit-button mat-raised-button" (click)="dismiss()">Close Pop-Up</button>
</mat-dialog-actions>
